export { default } from '@/features/campaignCreatePage/EditPage/styles';
